import React, { Component, useEffect, useState, useCallback } from "react";
import { getNeuroData } from '../../services/api/neuroScreen';
import { toast } from "react-toastify";
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import DefaultButton from "../../components/Button/Button";
const NeuroScreenDashboard = () => {
    const navigate = useNavigate();
    const [neuroData, setNeuroData] = useState([]);
    const [loading, setLoading] = useState(false);
const [loader, setLoader] = useState(false);
    const fetchNeuroData = useCallback(async () => {
        try {
            setLoading(true);
            const response = await getNeuroData();
            setNeuroData(response.data.data);
        } catch (error) {
            toast.error('Failed to load neuro data');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchNeuroData();
    }, [fetchNeuroData]);

    const handleRowClick = (row) => {
        let testType = '';
        if (row?.TestType === 'FaceAware') {
            testType = 'FaceAware';
        } else if (row?.TestType === 'TubeTest') {
            testType = 'TubeTest_Response';
        }
        navigate(`/neuroscreen/${testType}/${row?.SessionId}`);
    };

    return (
        <section class="page_section w-100 ps-lg-4 pe-lg-5">
        <div class="container-fluid">
            <div class="row justify-content-center">
                <div class="col-lg-6 col-md-12 col-sm-12 col-12 d-flex align-items-center">
                    <div class="page_title d-flex align-items-center">
                    <a href="javascript:void" style={{pointerEvents:'none'}}>NeuroScreen Dashboard</a>
                    </div>
                </div>
                <div class="col-lg-6 col-md-12 col-sm-12 col-12 d-flex align-items-center justify-content-end gap-3 mt-lg-0 mt-md-4 mt-3">
                    {/* <div class="view_test_button d-flex align-items-center">
                        <a download="sensify.csv" target="_self" href="blob:https://analytics.sensifyaware.com/1deb8a75-2460-4835-9a87-1c33f4b3c263" style="display: none;">Download CSV</a>
                        <button class="btn btn-primary bg-white ms-lg-4 ms-md-4 ms-3">Export</button>
                    </div> */}
                    {/* <div class="view_test_button d-flex align-items-center"><button class="btn btn-primary bg-white">Export</button></div> */}
                    {/* <DefaultButton
                className="colored_btn w-auto m-0 px-4"
                title={"Export"}
                loading={loader}
                htmlType={"submit"}
              /> */}
                </div>
            </div>
            <div class="row mt-lg-5 mt-md-4 mt-4">
                <div class="col-12">
                <div className='test_table neurotable d-flex align-items-start gap-lg-5 gap-md-4 gap-4 w-100 p-0'>
                <table className='table' border="1" style={{ width: '100%', borderCollapse: 'collapse', borderColor: '#000' }}>
                    <thead>
                        <tr>
                            <th >Study No</th>
                            <th >Research Id</th>
                            <th >Participant Id</th>
                            <th >DOB</th>
                            <th >Gender</th>
                            <th >Race/ Ethnicity</th>
                            <th >Smoker (Y/N)</th>
                            <th >Profession</th>
                            <th >Education Level</th>
                            <th >Medication Use</th>
                            <th >Personal health History</th>
                            <th >Family Health History</th>
                            <th >ScentAware odor Identification Score</th>
                            <th >Number Of Tests</th>
                            <th >ScentAware odor Threshold Score</th>
                            <th >Mental State Exam Score</th>
                            <th >GlanceAware Score</th>
                            <th >TraceAware Score</th>
                            <th >AudioAware Score</th>
                            <th colSpan={10} className='innerTable'>
                                {/* <table className='table m-0'> */}
                                <tr>
                                    <th colSpan={5}>OS</th>
                                    <th colSpan={5}>OD</th>
                                </tr>
                                <tr>
                                    <th>Macular GCIPL thickness</th>
                                    <th>Peripapillary RNFL thickness</th>
                                    <th>Cup-disc ratio</th>
                                    <th>Drusen</th>
                                    <th>Hyper Reflective Foci</th>
                                    <th>Macular GCIPL thickness</th>
                                    <th>Peripapillary RNFL thickness</th>
                                    <th>Cup-disc ratio</th>
                                    <th>Drusen</th>
                                    <th>Hyper Reflective Foci</th>
                                </tr>
                                {/* </table> */}
                            </th>
                            <th >Date/Time</th>
                        </tr>
                    </thead>

                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan={12} className="text-center">
                                    Loading...
                                </td>
                            </tr>
                        ) : neuroData.length === 0 ? (
                            <tr>
                                <td colSpan={12} className="text-center">
                                    No Data Available
                                </td>
                            </tr>
                        ) : (
                            neuroData.map((row, index) => (
                                <tr key={index}>
                                    <td>{row?.StudyNumber}</td>
                                    <td>{row?.ResearcherId}</td>
                                    <td>{row?.PatientId}</td>
                                    <td>
                                        {row?.DateOfBirth ? moment(row.DateOfBirth).format("MM-DD-YYYY") : ""}
                                    </td>
                                    <td>{row?.Gender}</td>
                                    <td>{row?.Ethnicity}</td>
                                    <td>{row?.IsSmoker ? "Yes" : "No"}</td>
                                    <td>{row?.Profession}</td>
                                    <td>{row?.EducationLevel}</td>
                                    <td>{row?.MedicationUse}</td>
                                    <td>{row?.PersonalHealthHistory || ""}</td>
                                    <td>{row?.FamilyHealthHistory}</td>
                                    <td style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={() => handleRowClick(row)}>{row?.TestType=="TubeTest"?row?.Score:""}</td>
                                    <td>{row?.TotalCount || ""}</td>
                                    {/* <td  style={{ cursor: 'pointer', textDecoration: 'underline' }} ><button className="btn btn-primary text-center px-3" onClick={() => handleRowClick(row)}>{row?.scentAwareOdorIdentificationScore}</button></td> */}
                                    <td>{row?.scentAwareOdorThresholdScore || ""}</td>
                                    <td>{row?.mentalStateExamScore || ""}</td>
                                    <td style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={() => handleRowClick(row)}>{row?.TestType=="FaceAware"?row?.Score:""}</td>
                                    {/* <td  style={{ cursor: 'pointer', textDecoration: 'underline' }} ><button className="btn btn-primary text-center px-3" onClick={() => handleRowClick(row)}>{row?.glanceAwareScore}</button></td> */}
                                    <td>{row?.traceAwareScore || ""}</td>
                                    <td>{row?.audioAwareScore || ""}</td>
                                    <td className="innerTable">{row?.macularGCIPLThicknessOS || ""}</td>
                                    <td className="innerTable">{row?.peripapillaryRNFLThicknessOS || ""}</td>
                                    <td className="innerTable">{row?.cupDiscRatioOS || ""}</td>
                                    <td className="innerTable">{row?.drusenOS || ""}</td>
                                    <td className="innerTable">{row?.hyperReflectiveFociOS || ""}</td>
                                    <td className="innerTable">{row?.macularGCIPLThicknessOD || ""}</td>
                                    <td className="innerTable">{row?.peripapillaryRNFLThicknessOD || ""}</td>
                                    <td className="innerTable">{row?.cupDiscRatioOD || ""}</td>
                                    <td className="innerTable">{row?.drusenOD || ""}</td>
                                    <td className="innerTable">{row?.hyperReflectiveFociOD || ""}</td>
                                    <td className="text-nowrap">
                                        {row?.CreatedDate ? moment(row.CreatedDate).format("MM-DD-YYYY hh:mm A") : ""}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
                </div>
            </div>
        </div>
    </section>

    );
};

export default NeuroScreenDashboard;
